import PageHeader from '../components/PageHeader';
import bgTwo from '../assets/images/bgTwo.png';
import secondHeader from '../assets/images/secondHeader.png';
import timeBG from '../assets/images/timeBG.png';
import court from '../assets/images/court.png'
import waight from '../assets/images/waight.png'
import pGroup from '../assets/images/pGroup.png'
import paper from '../assets/images/paper.png'
import avatarTwo from '../assets/images/avatarTwo.png'
import timeAvatar from '../assets/images/timeAvatar.png'
import yellowP from '../assets/images/yellowP.png'
import yellowpaper from '../assets/images/yellowpaper.png'
import AnimatedSection, { AnimatedGroup, AnimatedItem } from '../components/AnimatedSection';
import { Lightbulb, lightbulb } from 'lucide-react';

const Workshops = () => {
    const workshops = [
        {
          id: '01',
          title: 'ورشة العمل الأولى',
          subtitle: 'قراءة في حوكمة الشركات',
          speaker: 'الأستاذ راكان الحميميدي',
          speakerTitle: 'مدير عام الإدارة العامة لسياسات وأنظمة الشركات في وزارة التجارة',
          time: '08:30-09:30',
          ampm: 'صباحا',
          icon: court
        },
        {
          id: '02',
          title: 'ورشة العمل الثانية',
          subtitle: 'حوكمة الجوانب القانونية في القطاع العام',
          speaker: 'الأستاذ عبد الرؤوف القرشي',
          speakerTitle: 'مدير عام الحوكمة والمخاطر والالتزام في الهيئة العامة للعقار',
          time: '09:00-09:30',
          ampm: 'صباحا',
          icon: waight
        },
        {
          id: '03',
          title: 'ورشة العمل الثالثة',
          subtitle: 'الحوكمة من منظور المساهمين',
          speaker: 'د. علي محمد آل ساري',
          speakerTitle: ' عضو هيئة تدريس في كلية الحقوق والعلوم السياسية',
          time: '09:00-10:00',
          ampm: 'صباحا',
          icon: pGroup
        },
        {
          id: '04',
          title: 'ورشة العمل الرابعة',
          subtitle: 'التشريعات العقارية وأثرها في حوكمة الأنشطة العقارية',
          speaker: 'الأستاذ عبد الرحمن السنيدي',
          speakerTitle: 'مدير عام التشريعات في الهيئة العامة للعقار',
          time: '12:00-12:30',
          ampm: 'مساء',
          icon: paper
        },
        {
          id: '05',
          title: 'ورشة العمل الخامسة',
          subtitle: 'أساليب البحث القانوني التطبيقي',
          speaker: 'مركز الدراسات والبحوث القانونية',
          speakerTitle: 'مركز الدراسات والبحوث القانونية في هيئة الخبراء',
          time: '12:00-01:00',
          ampm: 'مساء',
          icon: paper
        }
      ];
    return (
        <>
            <PageHeader image={bgTwo} title="ورش العمل" />
            <AnimatedSection as="div" className="w-full bg-white py-10 px-4 sm:py-14 sm:px-6 md:py-20 overflow-x-hidden bg-contain" style={{ backgroundImage: `url(${timeBG})` }} amount={0.05}>
                <div className="mx-auto max-w-7xl">
                    <AnimatedGroup stagger={0.1} amount={0.05}>
                    {workshops.map((item, index) => (
                        <AnimatedItem key={item.id} className="flex relative mb-5 sm:mb-6 lg:mb-8">

                            <div className="w-12 sm:w-16 md:w-20 lg:w-24 shrink-0 flex justify-center relative">
                                {index !== workshops.length - 1 && (
                                <div className="absolute top-7 sm:top-8 md:top-9 bottom-[-1.25rem] sm:bottom-[-1.5rem] w-[2px] bg-[#a9c3d9] z-0"></div>
                                )}
                                <div className="relative z-10 w-10 h-10 sm:w-12 sm:h-12 md:w-16 md:h-16 bg-[#32749f] rounded-full flex items-center justify-center text-white text-sm sm:text-base md:text-xl font-bold ring-[2px] sm:ring-[2.5px] ring-[#D3A35D] ring-offset-white mt-1">
                                {item.id}
                                </div>
                            </div>

                            <div className="flex-1 min-w-0 bg-white rounded-xl sm:rounded-2xl p-4 sm:p-5 md:p-6 flex flex-col lg:flex-row gap-4 sm:gap-5 lg:gap-6 items-stretch lg:items-center shadow-[0px_0px_6.25px_0.91px_#00000040]">

                                <div className="flex-1 flex flex-col sm:flex-row items-center gap-3 sm:gap-4 text-center sm:text-right w-full lg:pl-6 min-w-0">
                                    <img src={item.icon} alt={item.title} className="w-12 h-12 sm:w-14 sm:h-14 md:w-16 md:h-16 shrink-0" />
                                    <div className="min-w-0 w-full">
                                        <h3 className="text-[#3E82B9] font-bold text-lg sm:text-xl md:text-2xl lg:text-[28px] mb-2 sm:mb-3 md:mb-4 lg:mb-6">{item.title}</h3>
                                        <p className="text-gray-700 font-normal text-base sm:text-lg md:text-xl lg:text-[27px] leading-snug break-words">{item.subtitle}</p>
                                    </div>
                                </div>

                                <div className="w-full lg:w-[35%] flex flex-col items-center text-center lg:border-r border-[#7299C0] lg:px-4 py-3 sm:py-4 lg:py-0 shrink-0 border-y lg:border-y-0">
                                    <div className="mb-2">
                                        <img src={avatarTwo} alt={item.speaker} className="w-12 h-12 sm:w-14 sm:h-14" />
                                    </div>
                                    <h4 className="text-[#3E82B9] font-bold text-base sm:text-lg md:text-xl lg:text-[22px] mb-1">{item.speaker}</h4>
                                    <p className="text-[#031246] text-sm sm:text-base md:text-[18px] font-normal max-w-[280px] lg:max-w-[200px] leading-relaxed">{item.speakerTitle}</p>
                                </div>

                                <div className="w-full lg:w-[20%] flex flex-col items-center text-center lg:border-r border-[#7299C0] lg:pr-4 shrink-0 py-2 lg:py-0">
                                    <div className="mb-1">
                                        <img src={timeAvatar} alt="time" className="w-12 h-12 sm:w-14 sm:h-14" />
                                    </div>
                                    <h4 className="text-[#3E82B9] font-bold text-base sm:text-lg md:text-xl lg:text-[22px] mb-1">الوقت</h4>
                                    <p className="text-[#031246] font-semibold text-sm sm:text-base md:text-[18px] tracking-wider" dir="ltr">{item.time}</p>
                                    <p className="text-[#DAA65B] text-sm sm:text-base font-bold mt-1">{item.ampm}</p>
                                </div>

                            </div>
                        </AnimatedItem>
                    ))}

                    <AnimatedItem className="w-full rounded-[16px] sm:rounded-[22px] bg-[#3E83B9] p-4 sm:p-6 mt-10 sm:mt-16">
                        {/* <Lightbulb className="text-white mx-auto mb-4 sm:mb-6 w-8 h-8 sm:w-10 sm:h-10" aria-label="ضوء" /> */}
                        {/* <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 100 100"
                            width={40}
                            height={40}
                            fill="none"
                            stroke="#DAA65B"
                            strokeWidth="4"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            className="mx-auto mb-4 sm:mb-6 w-8 h-8 sm:w-10 sm:h-10"
                            >
                            <path d="M 50 22 C 32 22, 28 40, 31 52 C 34 62, 40 68, 42 75 L 58 75 C 60 68, 66 62, 69 52 C 72 40, 68 22, 50 22 Z" />

                    
                            <line x1="42" y1="80" x2="58" y2="80" />
                            <line x1="44" y1="85" x2="56" y2="85" />
                            <path d="M 46 90 C 46 93, 54 93, 54 90" />

                    
                            <path d="M 42 75 L 42 60 L 50 50 L 58 60 L 58 75" strokeWidth="2.5" />
                            <circle cx="50" cy="50" r="2" fill="#FFF" stroke="none" />

                    
                            <line x1="50" y1="4" x2="50" y1="12" />          
                            <line x1="82" y1="16" x2="75" y2="23" />        
                            <line x1="96" y1="48" x2="86" y2="48" />        
                            <line x1="82" y1="80" x2="75" y2="73" />       
                            <line x1="4" y1="48" x2="14" y2="48" />
                            <line x1="18" y1="16" x2="25" y2="23" />
                        </svg> */}

<svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 100 100"
      width={70}
      height={70}
      className="mx-auto mb-4 sm:mb-6 w-16 h-16 sm:w-16 sm:h-16"
    >
      {/* Light Rays (Gold) */}
      <g stroke="#DAA65B" strokeWidth="4" strokeLinecap="round">
        <line x1="50" y1="4" x2="50" y2="12" />           {/* Top */}
        <line x1="82" y1="16" x2="75" y2="23" />         {/* Top Right */}
        <line x1="96" y1="48" x2="86" y2="48" />         {/* Right */}
        <line x1="82" y1="80" x2="75" y2="73" />         {/* Bottom Right */}
        <line x1="18" y1="80" x2="25" y2="73" />         {/* Bottom Left */}
        <line x1="4" y1="48" x2="14" y2="48" />          {/* Left */}
        <line x1="18" y1="16" x2="25" y2="23" />         {/* Top Left */}
      </g>

      {/* Bulb Glass (White) */}
      <path 
        d="M 50 22 C 32 22, 28 40, 31 52 C 34 62, 40 68, 42 75 L 58 75 C 60 68, 66 62, 69 52 C 72 40, 68 22, 50 22 Z" 
        stroke='#FFF'
        strokeWidth="4" 
        strokeLinecap="round" 
        strokeLinejoin="round" 
        fill="none" 
      />

      {/* Inner Filament (Gold) */}
      <path 
        d="M 42 75 L 42 60 L 50 50 L 58 60 L 58 75" 
        stroke='#FFF' 
        strokeWidth="2.5" 
        strokeLinecap="round" 
        strokeLinejoin="round" 
        fill="none" 
      />
      <circle cx="50" cy="50" r="2" fill='#FFD700' />

      {/* Bulb Base (Gray) */}
      <g stroke='#FFF' strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" fill="none">
        <line x1="42" y1="80" x2="58" y2="80" />
        <line x1="44" y1="85" x2="56" y2="85" />
        <path d="M 46 90 C 46 93, 54 93, 54 90" />
      </g>
    </svg>
                        <div className="md:flex justify-between gap-6 sm:gap-8 md:gap-10 lg:gap-16 md:px-20 px-12">
                            <div className="flex flex-col sm:flex-row items-center gap-12">
                                <img src={yellowpaper} alt="light" className="w-14 h-14 sm:w-[70px] sm:h-[70px] shrink-0" />
                                <div className="text-center min-w-0">
                                    <h3 className="text-[#DAA65B] font-bold text-[22px] mb-8">التسجيل</h3>
                                    <p className="text-white font-normal text-sm sm:text-base md:text-[18px] leading-relaxed">يتم التسجيل في كل ورشة على<br/> حدة عبر موقع المؤتمر</p>
                                </div>
                            </div>
                            <div className="flex flex-col sm:flex-row items-center gap-12 text-center">
                                <img src={yellowP} alt="light" className="w-14 h-14 sm:w-[70px] sm:h-[70px] shrink-0" />
                                <div className="min-w-0 text-center">
                                    <h3 className="text-[#DAA65B] font-bold text-[22px] mb-8">الفئة المستهدفة</h3>
                                    <p className="text-white font-normal text-sm sm:text-base md:text-[18px] leading-relaxed">المختصون والمهتمون في مجالات <br/>القانون والحوكمة والاعمال</p>
                                </div>
                            </div>
                        </div>
                    </AnimatedItem>
                    </AnimatedGroup>
                </div>
            </AnimatedSection>
        </>
    );
};

export default Workshops;
